import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public API
export const api = {
  // Photos
  getPhotos: (categoryId) => 
    axios.get(`${API}/photos${categoryId ? `?category_id=${categoryId}` : ''}`).then(r => r.data),
  
  // Categories
  getCategories: () => 
    axios.get(`${API}/categories`).then(r => r.data),
  
  // Settings
  getSettings: () => 
    axios.get(`${API}/settings`).then(r => r.data),
  
  // Contact
  submitContact: (data) => 
    axios.post(`${API}/contact`, data).then(r => r.data),
};

// Admin API
export const adminApi = {
  // Stats
  getStats: () => 
    axios.get(`${API}/admin/stats`).then(r => r.data),
  
  // Categories
  createCategory: (name) => 
    axios.post(`${API}/admin/categories`, { name }).then(r => r.data),
  deleteCategory: (id) => 
    axios.delete(`${API}/admin/categories/${id}`).then(r => r.data),
  
  // Cloudinary signature
  getCloudinarySignature: (folder = 'portfolio') =>
    axios.get(`${API}/cloudinary/signature?folder=${folder}`).then(r => r.data),
  
  // Upload image to Cloudinary
  uploadToCloudinary: async (file) => {
    // 1. Get signature from backend
    const sig = await adminApi.getCloudinarySignature('portfolio');
    
    // 2. Upload to Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', sig.api_key);
    formData.append('timestamp', sig.timestamp);
    formData.append('signature', sig.signature);
    formData.append('folder', sig.folder);
    
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`,
      { method: 'POST', body: formData }
    );
    
    return response.json();
  },
  
  // Photos - Create with Cloudinary URL
  createPhoto: (title, categoryId, imageUrl, publicId) => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('category_id', categoryId);
    formData.append('image_url', imageUrl);
    if (publicId) formData.append('public_id', publicId);
    
    return axios.post(`${API}/admin/photos`, formData).then(r => r.data);
  },
  
  deletePhoto: (id) => 
    axios.delete(`${API}/admin/photos/${id}`).then(r => r.data),
  
  // Messages
  getMessages: () => 
    axios.get(`${API}/admin/messages`).then(r => r.data),
  getMessageTemplates: (id) =>
    axios.get(`${API}/admin/messages/${id}/templates`).then(r => r.data),
  sendMessageReply: (id, data) =>
    axios.post(`${API}/admin/messages/${id}/reply`, data).then(r => r.data),
  markRead: (id) => 
    axios.patch(`${API}/admin/messages/${id}/read`).then(r => r.data),
  deleteMessage: (id) => 
    axios.delete(`${API}/admin/messages/${id}`).then(r => r.data),
  
  // Settings
  updateSettings: (data) => 
    axios.put(`${API}/admin/settings`, data).then(r => r.data),
};
